// extracted by mini-css-extract-plugin
module.exports = {"title-modal":"uqvnFQB5PBucsWHQtKV0v _398dXKGFKv7sbFR1sGkMbX"};